export const themes = [
    {
        id: 'matrix',
        name: 'Matrix Code',
        background: 'bg-[url(https://images.unsplash.com/photo-1526374965328-7f61d4dc18c5)] bg-cover bg-center',
        textColor: 'text-green-400',
        accentColor: 'from-green-600/40 via-green-500/40 to-emerald-500/40',
        menuBackground: 'bg-black/30',
        menuHoverBackground: 'hover:bg-green-900/30',
        editorBackground: 'bg-black/40'
    },
    {
        id: 'cosmic',
        name: 'Cosmic Dreams',
        background: 'bg-[url(https://images.unsplash.com/photo-1534796636912-3b95b3ab5986)] bg-cover bg-center',
        textColor: 'text-white',
        accentColor: 'from-purple-600/40 via-pink-500/40 to-blue-500/40',
        menuBackground: 'bg-black/30',
        menuHoverBackground: 'hover:bg-white/10',
        editorBackground: 'bg-black/20'
    },
    {
        id: 'forest',
        name: 'Mystic Forest',
        background: 'bg-[url(https://images.unsplash.com/photo-1542273917363-3b1817f69a2d)] bg-cover bg-center',
        textColor: 'text-emerald-50',
        accentColor: 'from-emerald-600/40 via-green-500/40 to-teal-500/40',
        menuBackground: 'bg-emerald-950/40',
        menuHoverBackground: 'hover:bg-emerald-800/30',
        editorBackground: 'bg-emerald-950/30'
    },
    {
        id: 'ocean',
        name: 'Deep Ocean',
        background: 'bg-[url(https://images.pexels.com/photos/2397651/pexels-photo-2397651.jpeg)] bg-cover bg-center',
        textColor: 'text-blue-50',
        accentColor: 'from-blue-600/40 via-cyan-500/40 to-indigo-500/40',
        menuBackground: 'bg-blue-950/40',
        menuHoverBackground: 'hover:bg-blue-800/30',
        editorBackground: 'bg-blue-950/30'
    },
    {
        id: 'sunset',
        name: 'Desert Sunset',
        background: 'bg-[url(https://images.unsplash.com/photo-1501862700950-18382cd41497)] bg-cover bg-center',
        textColor: 'text-orange-50',
        accentColor: 'from-orange-600/40 via-red-500/40 to-yellow-500/40',
        menuBackground: 'bg-orange-950/40',
        menuHoverBackground: 'hover:bg-orange-800/30',
        editorBackground: 'bg-orange-950/30'
    },
    {
        id: 'aurora',
        name: 'Northern Lights',
        background: 'bg-[url(https://images.unsplash.com/photo-1531366936337-7c912a4589a7)] bg-cover bg-center',
        textColor: 'text-green-50',
        accentColor: 'from-green-600/40 via-teal-500/40 to-blue-500/40',
        menuBackground: 'bg-green-950/40',
        menuHoverBackground: 'hover:bg-green-800/30',
        editorBackground: 'bg-green-950/30'
    },
    {
        id: 'cyberpunk',
        name: 'Cyberpunk City',
        background: 'bg-[url(https://images.unsplash.com/photo-1601042879364-f3947d3f9c16)] bg-cover bg-center',
        textColor: 'text-purple-50',
        accentColor: 'from-purple-600/40 via-pink-500/40 to-yellow-500/40',
        menuBackground: 'bg-purple-950/40',
        menuHoverBackground: 'hover:bg-purple-800/30',
        editorBackground: 'bg-purple-950/30'
    },
    {
        id: 'sakura',
        name: 'Cherry Blossom',
        background: 'bg-[url(https://images.unsplash.com/photo-1522383225653-ed111181a951)] bg-cover bg-center',
        textColor: 'text-pink-50',
        accentColor: 'from-pink-600/40 via-red-500/40 to-purple-500/40',
        menuBackground: 'bg-pink-950/40',
        menuHoverBackground: 'hover:bg-pink-800/30',
        editorBackground: 'bg-pink-950/30'
    },
    {
        id: 'galaxy',
        name: 'Galaxy Spiral',
        background: 'bg-[url(https://images.unsplash.com/photo-1462331940025-496dfbfc7564)] bg-cover bg-center',
        textColor: 'text-indigo-50',
        accentColor: 'from-indigo-600/40 via-purple-500/40 to-blue-500/40',
        menuBackground: 'bg-indigo-950/40',
        menuHoverBackground: 'hover:bg-indigo-800/30',
        editorBackground: 'bg-indigo-950/30'
    },
    {
        id: 'rainforest',
        name: 'Tropical Rain',
        background: 'bg-[url(https://images.pexels.com/photos/2544854/pexels-photo-2544854.jpeg)] bg-cover bg-center',
        textColor: 'text-emerald-50',
        accentColor: 'from-emerald-600/40 via-green-500/40 to-yellow-500/40',
        menuBackground: 'bg-emerald-950/40',
        menuHoverBackground: 'hover:bg-emerald-800/30',
        editorBackground: 'bg-emerald-950/30'
    },
    {
        id: 'volcano',
        name: 'Volcanic Night',
        background: 'bg-[url(https://images.unsplash.com/photo-1462332420958-a05d1e002413)] bg-cover bg-center',
        textColor: 'text-red-50',
        accentColor: 'from-red-600/40 via-orange-500/40 to-yellow-500/40',
        menuBackground: 'bg-red-950/40',
        menuHoverBackground: 'hover:bg-red-800/30',
        editorBackground: 'bg-red-950/30'
    }
];
